import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

// https://github.com/angular/components/blob/master/src/material/paginator/paginator-intl.ts
@Injectable({ providedIn: "root" })
export class FrMatPaginatorIntl extends MatPaginatorIntl {
    public override itemsPerPageLabel = "Rangées par page";

    public override nextPageLabel = "Prochaine page";

    public override previousPageLabel = "Page précédente";

    public override firstPageLabel = "Première page";

    public override lastPageLabel = "Dernière page";

    public override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length == 0 || pageSize == 0) {
            return `0 de ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;

        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
}

export const FR_MAT_PAGINATOR_PROVIDER = {
    provide: MatPaginatorIntl,
    useClass: FrMatPaginatorIntl
};
